import { WorkerMessageType } from "../../types/enums";
import { UnusualPhrases } from "../trigrams.ts/types";

export type UpdateTrigramPayload = {
  appId: string;
  clauses: Array<{ id: string; text: string }>;
  unusualPhrases: UnusualPhrases;
};

const SharedGlobalWorker = new SharedWorker(new URL("../../workers/index.ts", import.meta.url), {
  name: "background-update-worker",
  type: "classic",
  credentials: "same-origin",
});

SharedGlobalWorker.port.start();

export const dispatchUpdateTrigrams = (payload: UpdateTrigramPayload) => {
  SharedGlobalWorker.port.postMessage({ type: WorkerMessageType.UNUSUAL_TEXT_TRIGRAM_COUNTS, payload });
};

export default SharedGlobalWorker.port;
